<template>
    <body>
    <h1 class="hidden-sm-and-down">Добро пожаловать!</h1>
    <h1 class="hidden-sm-and-down">{{this.userInfo.title}}</h1>
    <h3 class="hidden-md-and-up">Добро пожаловать!</h3>
    <h3 class="hidden-md-and-up">{{this.userInfo.title}}</h3>
    <p>Готовьтесь к сезону и ждите обновлений!</p>
    <img  class="hidden-md-and-up logo_sm" v-bind:src="this.userInfo.logo"/>
    <img class="hidden-sm-and-down logo" v-bind:src="this.userInfo.logo"/>
    </body>
</template>

<script>
    export default {
        props: ['userInfo']
    }
</script>

